<div class="header-action-buttons">
    @if (!isMergeMoveModeOn()) {
        @if (isLocal() && isOnline) {
            <p-button
                doNotPropagateClick
                allowOffline
                label="Save Online"
                icon="pi pi-save"
                styleClass="p-button-secondary p-button-rounded"
                (onClick)="sendEpisodeFromCacheToServer()">
            </p-button>
        }
        @if (isApproveDraftButtonVisible) {
            <p-button
                doNotPropagateClick
                label="Approve Draft"
                icon="pi pi-save"
                styleClass="p-button-secondary p-button-rounded"
                (onClick)="navigateToEditEpisodeView()">
            </p-button>
        }
        @if (isSaveWalkInDraftButtonVisible) {
            <p-button
                doNotPropagateClick
                label="Approve Walk In Draft"
                icon="pi pi-save"
                styleClass="p-button-secondary p-button-rounded"
                (onClick)="approveWalkInDraftEpisode()">
            </p-button>
        }
    }

    @if(showViewButton()){
        <button doNotPropagateClick pButton type="button" class="ml-3 p-button-secondary" (click)="emitViewEpisode()">View</button>
    }

    <button
        doNotPropagateClick
        pButton
        pRipple
        type="button"
        icon="mi mi-info"
        class="p-button-secondary p-button-rounded p-button-text"
        (click)="episodeInfo.toggle($event)">
    </button>

    @if(episode()?.isMasterEpisode){
        @if (loadingMergedEpisodes()) {
            <ng-container *miproLoading="loadingMergedEpisodes(); diameterPx: '17px'"></ng-container>
        }
        <button
            [hidden]="loadingMergedEpisodes()"
            doNotPropagateClick
            pRipple
            pButton
            type="button"
            label="m"
            class="p-button-secondary p-button-rounded p-button-text merge-icon"
            (click)="getMergedInfo(episodeMergedInfo, $event)">
        </button>
    }

    @if(!isMergeMoveModeOn()){
        @if (showBanButtonComputed()) {
            <button
                doNotPropagateClick
                pButton
                pRipple
                type="button"
                class="p-button-secondary"
                label="Close"
                [disabled]="!isOnline"
                (click)="menuEpisodeBan.toggle($event)">
            </button>
        }
        @if (showPlusButtonComputed()) {
            <button
                doNotPropagateClick
                pButton
                pRipple
                allowOffline
                type="button"
                class="p-button-quaternary"
                label="Add"
                (click)="menuEpisodePlus.toggle($event)">
            </button>
        }
        @if (showEllipsisButtonComputed()) {
            <button
                doNotPropagateClick
                pButton
                pRipple
                allowOffline
                type="button"
                icon="mi mi-button-more"
                class="p-button-secondary p-button-rounded p-button-text"
                (click)="menuEpisodeEllipsis.toggle($event)">
            </button>
        } @else {
            <button
                doNotPropagateClick
                pButton
                pRipple
                type="button"
                icon="mi mi-button-more"
                class="p-button-secondary p-button-rounded p-button-text mip-disabled"
                disabled>
            </button>
        }
    }
</div>

<p-menu #menuEpisodePlus [popup]="true" [model]="episodeOptionsButtonPlusItems()" appendTo="body"></p-menu>
<p-menu #menuEpisodeEllipsis [popup]="true" [model]="episodeOptionsButtonEllipsisItems()" appendTo="body"></p-menu>
<p-menu #menuEpisodeBan [popup]="true" [model]="episodeOptionsButtonBanItems()" appendTo="body"></p-menu>

<p-overlayPanel #episodeInfo appendTo="body">
    @if (episode()?.diagnoses?.length) {
        @for (diagnose of episode().diagnoses; track diagnose.id) {
            <div class="diagnosis-row">
                <m-diagnosis-badge
                    class="diagnosis-code-icon"
                    [isOSIICSCode]="diagnose.diagnosisIsOSIICSCode">
                </m-diagnosis-badge>
                <span class="diagnosis-info">{{ diagnose.diagnosisCode }}</span>
            </div>
        }
    }

    @if (!isLimitedAccess()) {
        @if (episode()?.assignedClinicianUserId) {
            <m-user-initials
                header="Assigned Clinician:"
                [title]="episode()?.assignedClinicianUserTitle"
                [fullName]="episode()?.assignedClinicianUserFullName"
                [role]="episode()?.assignedClinicianUserRole"
                circleStyleClass="created-by">
            </m-user-initials>
        }

        <m-user-initials
            [header]="createdDateInfo()"
            [title]="episode()?.userTitle"
            [fullName]="episode()?.userFullName"
            [role]="episode()?.userRole"
            circleStyleClass="created-by">
        </m-user-initials>

        @if (episode()?.modifiedUserId) {
            <m-user-initials
                [header]="updatedDateInfo()"
                [title]="episode()?.modifiedUserTitle"
                [fullName]="episode()?.modifiedUserFullName"
                [role]="episode()?.modifiedUserRole"
                circleStyleClass="updated-by">
            </m-user-initials>
        }
        <div class="episode-info">
            <p>Owned by: {{ organizationName() }}</p>
            <p>{{ ravenIssueStatus() }}</p>
            <p>{{ ravenIssueRN() }}</p>
        </div>
    }
</p-overlayPanel>

<create-player-dialog
    [data]="offlinePatient()"
    [(visible)]="showPatientDialog"
    (visibleChange)="closedPatientOnlineMsg()"
    (playerCreated)="onPatientSaved($event)">
</create-player-dialog>

<p-overlayPanel #episodeMergedInfo appendTo="body">
    <h5>Merged Episodes:</h5>
    <!-- max-height not working on this scroll panel.
         setting an approximate height based on the number of merged episodes -->

    @if (mergedEpisodes().length > 0) {
        <p-scrollPanel>
            @for (mergedEpisode of mergedEpisodes(); track mergedEpisode.id) {
                <div class="mb-2 m-info">
                    <episode-header-v2
                        [episode]="mergedEpisode"
                        [showPlusButton]="false"
                        [showEllipsisButton]="false">
                    </episode-header-v2>
                </div>
            }
        </p-scrollPanel>
    }
</p-overlayPanel>
